import React from 'react';
import { cn } from '../../utils/cn';
import { isWhiteLabel } from '../../config/tenantConfig';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, disabled, size = 'md', label }) => {
  const sizes = {
    sm: { track: 'w-7 h-4', thumb: 'w-3 h-3', translate: 'translate-x-3' },
    md: { track: 'w-9 h-5', thumb: 'w-4 h-4', translate: 'translate-x-4' },
    lg: { track: 'w-11 h-6', thumb: 'w-5 h-5', translate: 'translate-x-5' },
  };
  const s = sizes[size];

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      title={label}
      onClick={onChange}
      disabled={disabled}
      className={cn(
        `relative inline-flex shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 ${isWhiteLabel() ? 'focus:ring-zebu-500' : 'focus:ring-blue-500'} focus:ring-offset-2 dark:focus:ring-offset-gray-900`,
        s.track,
        checked ? 'bg-green-500' : 'bg-gray-300 dark:bg-gray-600',
        disabled && 'opacity-50 cursor-not-allowed',
      )}
    >
      <span
        className={cn(
          'pointer-events-none inline-block rounded-full bg-white shadow transform transition-transform duration-200 ease-in-out',
          s.thumb,
          checked ? s.translate : 'translate-x-0',
        )}
      />
    </button>
  );
};

export default ToggleSwitch;
